import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

// Break points in this xs, 720, md,lg

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 25px 15px',
    backgroundColor: theme.palette.whitePepper.main,

    [theme.breakpoints.up('sm')]: {
      padding: '30px 50px 15px',
    },

    [theme.breakpoints.up('md')]: {
      padding: '40px 50px 25px',
    },
  },

  container: {
    flexGrow: 1,
    maxWidth: '1050px',
  },

  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: '15px',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    rowGap: '10px',

    [theme.breakpoints.up(720)]: {
      flexDirection: 'row',
      columnGap: '20px',
    },
  },

  key: {
    flexShrink: '0',
    textTransform: 'uppercase',
    maxWidth: '305px',

    [theme.breakpoints.up(720)]: {
      width: '260px',
    },

    [theme.breakpoints.up('md')]: {
      width: '305px',
    },
  },
});
